import { defineStore } from 'pinia';
import Api from '@/utils/api'
import { useRouter } from 'vue-router';
const router=useRouter()

export const useStore = defineStore('global', {
    state: () => ({
        type:localStorage.getItem('global_type')|| 1, // 固定参数，默认值设为 0未提交 1待审核 2审核中
        // botData: { // 新增用户数据
        //     phone: '+86 (0) 574 88180000 (转8562或8563)', // 默认值
        //     email: 'CRBl@nottingham.edu.cn',    // 默认值
        //     postal: '315100'
        // },
        isAuthenticated: !!localStorage.getItem('token') // 根据token判断是否认证
    }),
    getters: {
        // 可选：定义一个 getter 方便获取 type
        getType: (state) => state.type,
        getBotData: (state) => state.botData,
    },
    actions: {
        // 修改 type
        async setType(newType) {
            this.type = newType;
            const res=await Api.getUserStatus()
                if(res.code==200){
                    this.type=res.data.status
                    localStorage.setItem('global_type', this.type)
                }else if(res.code==401){
                    this.logout()
                    router.push({
                        path:'login',
                        query:{
                            currentIdentity:'login'
                        }
                    })
                }
        },
        async fetchUserData() {
            try {
                const res = await Api.getInfo() 
                if (res.code == 200) {
                    this.botData = {
                        phone: res.data[0].phone, 
                        email: res.data[0].email,
                        postal: res.data[0].postal
                    }
                }
            } catch (error) {
                console.error('获取用户数据失败:', error);
            }
        },
        // 登录方法
        async login(credentials) {
            try {
                const res = await Api.onLogin(credentials)
                if (res.code === 200) {
                    localStorage.setItem('token', res.data.token)
                    this.isAuthenticated = true
                    return true
                }
                return false
            } catch (error) {
                return false
            }
        },
        
        // 登出方法
        async logout() {
            const res=await Api.onLogout()
            if(res.code==200){
                localStorage.clear()
                this.isAuthenticated = false
                this.type = 1
            }
        },
    }
});
